import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  private declare timeoutId: any | undefined

  private get turbo (): any {
    const Turbo = (window as any).Turbo

    return Turbo
  }

  private get progressBar (): any {
    return this.turbo?.navigator?.adapter?.progressBar
  }

  start (): void {
    if (this.progressBar != null) {
      this.progressBar.show()

      this.timeoutId = setTimeout(() => {
        this.progressBar.hide()
      }, 30000)
    }
  }

  connect (): void {
    this.handleFrameLoad = this.handleFrameLoad.bind(this)
    document.addEventListener('turbo:frame-load', this.handleFrameLoad)
  }

  disconnect (): void {
    if (this.timeoutId != null) {
      clearTimeout(this.timeoutId)
    }
    document.removeEventListener('turbo:frame-load', this.handleFrameLoad)
  }

  handleFrameLoad (event: Event): void {
    if (this.progressBar != null) {
      this.progressBar.hide()
    }
    if (this.timeoutId != null) {
      clearTimeout(this.timeoutId)
    }
  }
}
